export default __webpack_public_path__ + "static/media/wind_speed.0433c2c4.svg";